export const CATEGORIES = [
  { value: "iPad", label: "iPad" },
  { value: "MacBook", label: "MacBook", id: "MacBook", name: "MacBook" },
  { value: "Chromebook", label: "Chromebook" },
];
